import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import type {RootState} from './store';
import {employeesigninApiCall} from '../api/employeesignin-api';
import {
  employeePasswordResponse,
  employeeResetPasswordRequest,
} from '../lib/types';
import {employeeresetpasswordapicall} from '../api/employeepassword.api';
//import axios from 'axios';

const employeePasswordData = {
  statusCode: '',
  statusMessage: '',
};

interface employeeSigninState {
  employeeApiResponse: employeePasswordResponse;
  loading: boolean;
  error: string;
}

// Define the initial state using that type
const initialState: employeeSigninState = {
  employeeApiResponse: employeePasswordData,
  loading: false,
  error: '',
};

export const employeeResetPassword = createAsyncThunk(
  'employee/employeereset',
  async (parameters: employeeResetPasswordRequest, thunkApi) => {
    return employeeresetpasswordapicall(parameters)
      .then(response => {
        return response;
      })
      .catch(error => {
        return thunkApi.rejectWithValue(error.response.data);
      });
  },
);
export const employeeResetPasswordSlice = createSlice({
  name: 'employeeresetpassword',
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    resetState: () => initialState,
  },
  extraReducers: builder => {
    builder.addCase(employeeResetPassword.pending, state => {
      state.loading = true;
    });
    builder.addCase(employeeResetPassword.fulfilled, (state, action) => {
      state.loading = false;
      state.employeeApiResponse = action.payload;
    });
    builder.addCase(employeeResetPassword.rejected, (state, action) => {
      state.error = action.toString();

      state.loading = false;
    });
  },
});

//Other code such as selectors can use the imported `RootState` type
export const {resetState} = employeeResetPasswordSlice.actions;

export const employeeResetPasswordData = (
  state: RootState,
): employeePasswordResponse =>
  state.employeeResetPasswordReducer.employeeApiResponse;
export const error = (state: RootState): string =>
  state.employeeResetPasswordReducer.error;
export const loading = (state: RootState): boolean =>
  state.employeeResetPasswordReducer.loading;

export default employeeResetPasswordSlice.reducer;
